import React from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';

const STEP_ICONS = ['1', '2', '3', '4', '5', '6', '7'];
const STEP_KEYS = [
  'onboarding.step1.title',
  'onboarding.step2.title',
  'onboarding.step3.title',
  'onboarding.step4.title',
  'onboarding.step5.title',
  'onboarding.step6.title',
  'onboarding.step7.title',
];

export default function OnboardingProgress({ currentStep, totalSteps = 7 }) {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      {/* Step indicator */}
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-[#8a8474]">
          {t('onboarding.stepOf', { current: currentStep, total: totalSteps })}
        </span>
      </div>

      {/* Progress bar */}
      <div className="flex items-center gap-1">
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((num) => (
          <div key={num} className="flex items-center flex-1">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold shrink-0 transition-all duration-300 ${
                currentStep === num
                  ? 'bg-[#1f4d3a] text-white ring-2 ring-[#1f4d3a]/50 scale-110'
                  : currentStep > num
                  ? 'bg-[#1e7a4f] text-white'
                  : 'bg-[#e9e2d2] text-[#8a8474]'
              }`}
            >
              {currentStep > num ? (
                <Check className="w-3.5 h-3.5" />
              ) : (
                STEP_ICONS[num - 1]
              )}
            </div>
            {num < totalSteps && (
              <div
                className={`h-0.5 flex-1 mx-1 rounded transition-all duration-300 ${
                  currentStep > num ? 'bg-[#1e7a4f]' : 'bg-[#e9e2d2]'
                }`}
              />
            )}
          </div>
        ))}
      </div>

      {/* Step labels */}
      <div className="flex justify-between mt-1.5 px-0.5">
        {STEP_KEYS.map((key, i) => (
          <span
            key={key}
            className={`text-[10px] text-center flex-1 ${
              currentStep === i + 1
                ? 'text-[#1f4d3a] font-medium'
                : currentStep > i + 1
                ? 'text-[#1e7a4f]'
                : 'text-[#9c9585]'
            }`}
          >
            {t(key)}
          </span>
        ))}
      </div>
    </div>
  );
}
